document.addEventListener('DOMContentLoaded', function() {
  const detailsElement = document.getElementById('Details-HeaderMenu-1');
  const summaryElement = document.getElementById('HeaderMenu-collections');
  const megaMenuContent = document.getElementById('MegaMenu-Content-1');
  const headerMenuItem = detailsElement.closest('li');
  let closeTimeout;

  if (headerMenuItem && detailsElement) {
    const openMenu = () => {
      clearTimeout(closeTimeout);
      detailsElement.setAttribute('open', '');
      detailsElement.setAttribute('aria-expanded', 'true');
    };

    const closeMenu = () => {
      closeTimeout = setTimeout(() => {
        if (!headerMenuItem.matches(':hover') && !megaMenuContent.matches(':hover')) {
          detailsElement.removeAttribute('open');
          detailsElement.setAttribute('aria-expanded', 'false');
        }
      }, 150); // Add a slight delay to prevent premature closing
    };

    // Open on hover over the menu item
    headerMenuItem.addEventListener('mouseenter', openMenu);

    // Keep open when hovering the mega menu content
    megaMenuContent.addEventListener('mouseenter', openMenu);

    // Close when mouse leaves both the menu item and mega menu content
    headerMenuItem.addEventListener('mouseleave', closeMenu);
    megaMenuContent.addEventListener('mouseleave', closeMenu);

    // Prevent default click behavior
    summaryElement.addEventListener('click', (e) => {
      e.preventDefault();
    });
  }
});
